module.exports = __webpack_public_path__ + "static/media/policy_question.43cae68e.mp3";